import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { getCustomerId } from './Common';
import { clearStrataZeitroAuthCookies, handleAuthExpired } from './syncStrataSession.js';

const LOGOUT_SESSION_KEYS = [
    'lastUsedGuideline',
    'activeGPTmode',
    'selectedFilters',
    'selectedFiltersScenario',
    'selectedGuidelines',
    'selectedPrograms',
    'scenario_tag',
    'scenario_guideline',
    'scenario_lender_expand',
    'notif-lenders',
    'path',
    'state',
    'originalstate',
]

export function goToAppLogout(history) {
    LOGOUT_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key))
    if (history && typeof history.push === 'function') {
        history.push('/app/logout')
        return
    }
    window.location.assign('/app/logout')
}

export function clearLoginSessionImmediately() {
    LOGOUT_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key))
    handleAuthExpired()
}

function LogoutPage()  {
    const customerid = getCustomerId()
    const url = "/login/" + customerid

    window.sessionStorage.removeItem("ZeitroA")
    window.sessionStorage.removeItem("path")
    clearStrataZeitroAuthCookies()

    window.location.href = url
    return (
        <div>
        </div>
    )
}

export default LogoutPage;

